export const iconFontAwesomeDesignPalette = (
	<i className="fa-solid fa-palette"></i>
);
